import { memo } from "react";
import { useTranslation } from "react-i18next";

import { GlobalSearchKbd } from "./GlobalSearchKbd";

// NOTE: The keyboard contract of the palette, spelled out — label first, keys
// after, as in the screenshots NSAI-6853 was modelled on. Hidden on narrow
// screens, where nobody drives it from a keyboard.
const GlobalSearchFooterComponent = (): JSX.Element => {
  const { t } = useTranslation("globalSearch");

  return (
    <div
      className="hidden flex-wrap items-center gap-x-5 gap-y-1.5 border-t border-glass-edge px-5 py-3 text-xs text-foreground-secondary sm:flex"
      data-testid="global-search-footer"
    >
      <span className="flex items-center gap-1.5 whitespace-nowrap">
        {t("keyboard.close")}
        <GlobalSearchKbd>Esc</GlobalSearchKbd>
      </span>
      <span className="flex items-center gap-1.5 whitespace-nowrap">
        {t("keyboard.switch_tab")}
        <GlobalSearchKbd>←</GlobalSearchKbd>
        <GlobalSearchKbd>→</GlobalSearchKbd>
      </span>
      <span className="flex items-center gap-1.5 whitespace-nowrap">
        {t("keyboard.navigate")}
        <GlobalSearchKbd>↑</GlobalSearchKbd>
        <GlobalSearchKbd>↓</GlobalSearchKbd>
      </span>
      <span className="flex items-center gap-1.5 whitespace-nowrap">
        {t("keyboard.open")}
        <GlobalSearchKbd>↵</GlobalSearchKbd>
      </span>
    </div>
  );
};

export const GlobalSearchFooter = memo(GlobalSearchFooterComponent);
